var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"switcher",class:("switcher--" + _vm.type),on:{"click":function($event){_vm.$emit('click')}}},[_c('span',{staticClass:"switcher__icon"}),_vm._v(" "),_c('span',{staticClass:"switcher__text",domProps:{"innerHTML":_vm._s(_vm.switcherText)}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dbc679c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Map/Switcher.vue
// module id = null
// module chunks = 